import { render, staticRenderFns } from "./SpkbBpbDetail.vue?vue&type=template&id=1d4f3e6d&"
import script from "./SpkbBpbDetail.vue?vue&type=script&lang=js&"
export * from "./SpkbBpbDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpkbBpbDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports